import React from "react";
import {Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { useState } from 'react';
import { useMediaQuery } from '@mui/material';

const customStyle =  makeStyles({
  root: {
    padding: "60px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
    formInput: {
      padding: "16px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "18px",
      width: "250px",
      marginLeft:"25px"
    },
    '@media (max-width: 390px)': {
      root: {
        padding: "60px 10px",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: "5px",
      },
        formInput: {
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontSize: "14px",
          width: "115px",
          marginLeft:"5px"
        },
    },
});

const Layout = (props) => {
  const {
  } = props;
  const classes = customStyle();
  const isPhone = useMediaQuery('(max-width: 390px)');

  // Inline CSS for the iframe container and the iframe itself

  const [searchQuery, setSearchQuery] = useState('');
  const [videos] = useState([
    { id: 1, title: 'How to add Pod', url: 'https://drive.google.com/file/d/18RR8yGUYhC9zfOAWM70bFuZV99ReB6pU/preview' },
    { id: 2, title: 'How to add Campus', url: 'https://drive.google.com/file/d/18RR8yGUYhC9zfOAWM70bFuZV99ReB6pU/preview' },
    { id: 3, title: 'How to add Vendor', url: 'https://drive.google.com/file/d/18RR8yGUYhC9zfOAWM70bFuZV99ReB6pU/preview' },
    { id: 4, title: 'How to use Carting Tool', url: 'https://drive.google.com/file/d/18RR8yGUYhC9zfOAWM70bFuZV99ReB6pU/preview' },
  ]);
  const [filteredVideos, setFilteredVideos] = useState(videos);

  // Function to handle the search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Function to handle the search button click
  const handleSearchClick = () => {
    const filtered = videos.filter((video) =>
      video.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredVideos(filtered);
  };

  return (
    <div className={classes.root} style={{marginTop:"-30px"}}>
     <div style={{marginTop:"-30px"}}>
     
     <input
        className={classes.formInput}
        type={"text"}
        placeholder={"Search videos..."}
        value={searchQuery}
        onChange={handleSearchChange}
      />
    
      <Button
              variant="contained"
              style={{
                color: "white",
                backgroundColor: "#FF5722",
                padding: "12px 24px",
                borderRadius: "10px",
                marginLeft:"25px",
                fontSize:isPhone?"8px":"inherit",
              }}
              onClick={handleSearchClick}
            >
              Search
            </Button>
      
      <div style={{display:"flex",justifyContent:"space-evenly",flexWrap:"wrap"}}>
        {filteredVideos.length > 0 ? (
          filteredVideos.map((video) => (
            <div key={video.id} style={{
              margin: '-5px 0',
              width: isPhone ? '100%' : '460px', // Full width on mobile, fixed width on larger screens
              boxSizing: 'border-box', // Include padding in width calculations
            }}>
              <h5 style={{
                fontSize: isPhone ? '10px' : '16px', // Adjust font size based on screen size
                textAlign: isPhone ?'left' : 'center', // Center align text
              }}>{video.title}</h5>
              <iframe
                style={{
                  width: '100%', // Responsive width
                  height: isPhone ? '125px' : '250px', // Adjust height for mobile
                  borderRadius: '8px', // Optional for styling
                }}
                src={video.url}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                sandbox="allow-same-origin allow-scripts"
              ></iframe>
            </div>
          ))
        ) : (
          <p>No videos found.</p>
        )}
      </div>
    </div>
    </div>
  );
};

export default Layout;
